import API from "@/api/AppealsAPI";
import {idUserForApi} from "@/controllers/UserController";

class AppealController {
  constructor() {
    this.api = API;
    this.mock = false
  }

  _checkId(id, text = 'id cannot be null') {
    if (!id)
      throw new Error(text);
  }

  /**
   *
   * @param { string } id
   * */
  async getAppeal(id,) {
    try {
      this._checkId(id);
      const res = this.mock ? {data: [], status: 200} : await this.api.getById(id);
      return res.data
    } catch (e) {
      console.error('error getAppeal ' + e.message)
      throw new Error('error getAppeal ' + e.message)
    }
  }

  /**
   *
   * @param { Number | null | undefined } [orgId]
   * */
  async getAppeals(orgId,) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId, 'orgId cannot be null');
      const res = this.mock ? {data: [], status: 200} : await this.api.read(orgId);
      return res.data
    } catch (e) {
      console.error('error getAppeals ' + e.message)
      throw new Error('error getAppeals ' + e.message)
    }
  }

  async setAppeal(data) {
    try {
      let res;
      if (data.id)
        res = this.mock ? {data: {...data}, status: 200} : await this.api.setAppeal(data);
      else
        res = this.mock ? {data: {...data, id: Math.random()}, status: 200} : await this.api.setAppeal(data);
      return res.data
    } catch (e) {
      console.error('error setAppeal ' + e.message)
      throw new Error('error setAppeal ' + e.message)
    }
  }

  /**
   * @description appeal for forms 5.15 5.18 5.19 5.20
   * */
  async setAppealByKey(data) {
    try {
      let res;
      if (data.id)
        res = this.mock ? {data: {...data}, status: 200} : await this.api.setAppealByKey(data)
      else
        res = this.mock ? {data: {...data, id: Math.random()}, status: 200} : await this.api.setAppealByKey(data);
      return res.data
    } catch (e) {
      console.error('error setAppeal ' + e.message)
      throw new Error('error setAppeal ' + e.message)
    }
  }

  /**
   * @param {{
   *       "id": string,
   *   "reason": boolean,
   *   "newValue": string,
   *   "decision": string
   * }} data
   * */
  async closeAppeal(data) {
    try {
      const res = await this.api.closeAppeal(data);
      return res.data;
    } catch (e) {
      console.error(e.message)
      throw new Error('error closeAppeal ' + e.message)
    }
  }

}

export default new AppealController();